if (!customElements.get('wls-video-feature')) {
  class WLSVideoFeature extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        videoContainer: 'wls-video-feature__video-container',
        playButton: 'wls-video-feature__play-button',
        poster: 'wls-video-feature__poster',
        iframeContainer: 'wls-video-feature__iframe-container',
        iframe: 'wls-video-feature__iframe',
        video: 'wls-video-feature__video',
        hidden: 'wls-video-feature__hidden',
        addToCartButton: 'wls-video-feature__button--add-to-cart',
      };
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.teardown();
    }

    init() {
      const containers = this.querySelectorAll(`.${this.classes.videoContainer}`);
      
      containers.forEach(container => {
        const playButton = container.querySelector(`.${this.classes.playButton}`);
        const poster = container.querySelector(`.${this.classes.poster}`);
        const videoType = container.getAttribute('data-video-type');
        
        if (playButton) {
          playButton.addEventListener('click', () => {
            if (videoType === 'youtube' || videoType === 'vimeo') {
              const iframeContainer = container.querySelector(`.${this.classes.iframeContainer}`);
              const iframe = container.querySelector(`.${this.classes.iframe}`);
              
              if (iframeContainer && iframe) {
                if (poster) poster.classList.add(this.classes.hidden);
                iframeContainer.classList.remove(this.classes.hidden);
                iframe.src = iframe.getAttribute('data-src');
              }
            } else if (videoType === 'file') {
              const video = container.querySelector(`.${this.classes.video}`);
              
              if (video) {
                if (poster) poster.classList.add(this.classes.hidden);
                video.classList.remove(this.classes.hidden);
                video.play();
              }
            }
          });
        }
      });
    }

    teardown() {
      const containers = this.querySelectorAll(`.${this.classes.videoContainer}`);
      containers.forEach(container => {
        const playButton = container.querySelector(`.${this.classes.playButton}`);
        if (playButton) {
          playButton.removeEventListener('click', this.boundPlayVideo);
        }
      });
    }
  }

  customElements.define('wls-video-feature', WLSVideoFeature);
}
